import React from "react";

const BhioLogo: React.FC = () => (
  <img src="/logo-blue.png" alt="Bhiotrack Logo" width={45} height={45} />
);

export default BhioLogo;
